// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { FichaExtra } from '../contabil/ficha-extra.model';
import { ContaBancaria } from './conta-bancaria.model';
import { Exercicio } from '../comum/exercicio.model';
import { Orgao } from '../comum/orgao.model';
import { RetencaoExtra } from '../contabil/retencao-extra.model';
import { Retencao } from '../contabil/retencao.model';
import { RetencaoResto } from '../contabil/retencao-resto.model';
import { ContaBancariaRecurso } from './conta-bancaria-recurso.model';

export class RecebimentoExtra extends BaseResourceModel {
  constructor(
    public id?: number,
    public data_recebimento?: Date,
    public data_referencia?: Date,
    public mes?: number,
    public especie?: string,
    public guia?: string,
    public historico?: string,
    public valor_recebido?: number,
    public retido?: boolean,
    public ficha?: FichaExtra,
    public conta?: ContaBancaria,
    public exercicio?: Exercicio,
    public orgao?: Orgao,
    public retencao?: Retencao,
    public retencao_resto?: RetencaoResto,
    public retencao_extra?: RetencaoExtra,
    public aux?: number,
    public data_cadasxtro?: Date,
    public data_alteracao?: Date,
    public conta_recurso?: ContaBancariaRecurso,
    public nome_arquivo?: string,
    public numero_apr?: string,
    public numero_parcelamento_rpps?: string,
  ) {
    super();
  }

  static converteJson(json: any): RecebimentoExtra {
    return Object.assign(new RecebimentoExtra(), json);
  }
}
